export default __webpack_public_path__ + "static/media/CodeUsageBulkTemplate.fe3f83e3.xlsx";